import Countdown from 'react-countdown'
import { StatBar } from '../stats/StatBar'
import { Histogram } from '../stats/Histogram'
import { GameStats } from '../../lib/localStorage'
import { shareStatus } from '../../lib/share'
import { tomorrow } from '../../lib/words'
import { BaseModal } from './BaseModal'
import { solution } from '../../lib/words'
import {
  STATISTICS_TITLE,
  GUESS_DISTRIBUTION_TEXT,
  NEW_WORD_TEXT,
  SHARE_TEXT,
} from '../../constants/strings'
let geojsonList = `https://geostarters.github.io/wordleicgc/geojson/wordle_list.geojson`

let listArray

let toponim = ''
let municipi = ''

fetch(geojsonList)
  .then((res) => res.json())
  .then((json) => {

    listArray = json.features

    let solutionlowercase = solution.toLowerCase()
    for (let i = 0; i < listArray.length; i++) {

      if (listArray[i].properties.topon_sa === solutionlowercase) {
        // console.log(listArray[i])

        toponim = listArray[i].properties.toponim
        municipi = listArray[i].properties.nommun1

      }
    }
  })








type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: string[]
  gameStats: GameStats
  isGameLost: boolean
  isGameWon: boolean
  linkWord: () => void
  handleShare: () => void
  isHardMode: boolean
}

export const StatsModal = ({
  isOpen,
  handleClose,
  guesses,
  gameStats,
  isGameLost,
  isGameWon,
  linkWord,
  handleShare,
  isHardMode,
}: Props) => {
  if (gameStats.totalGames <= 0) {
    return (
      <BaseModal
        title={STATISTICS_TITLE}
        isOpen={isOpen}
        handleClose={handleClose}
      >
        <StatBar gameStats={gameStats} />

      </BaseModal>
    )

  }
  return (
    <BaseModal
      title={STATISTICS_TITLE}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <StatBar gameStats={gameStats} />
      <h4 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
        {GUESS_DISTRIBUTION_TEXT}
      </h4>
      <Histogram gameStats={gameStats} />
      {(isGameLost || isGameWon) && (
        <div className="mt-5 sm:mt-6 columns-2 dark:text-white">
          <div>
            <h5>{NEW_WORD_TEXT}</h5>
            <Countdown
              className="text-lg font-medium text-gray-900 dark:text-gray-100"
              date={tomorrow}
              daysInHours={true}
            />
          </div>
          <button
            type="button"
            className="mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white   sm:text-sm"
            onClick={() => {
              shareStatus(guesses, isGameLost, isHardMode)
              handleShare()
            }}
          >
            {SHARE_TEXT}
          </button>
        </div>


      )}
      <div >
        <button
          type="button"
          className="localitza mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white  sm:text-sm"
          onClick={() => {
            linkWord()

          }}
        >
          Localitza el teu topònim
        </button>
        <h4 className="text-md leading-6 font-medium text-gray-900 dark:text-gray-100">Topònim: {toponim}</h4>
        <h4 className="text-md leading-6 font-medium text-gray-900 dark:text-gray-100">Municipi: {municipi}</h4>


      </div>
    </BaseModal>
  )
}
